import { ContentfulModel } from './ContentfulModel';
import { Document } from '@contentful/rich-text-types';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';

export class Tip extends ContentfulModel {
    private quote: string;
    private quoteFrom: string;
    private tip: Document;

    parseContentfulData(object: any): void {
        this.quote = object.quote;
        this.quoteFrom = object.quoteFrom;
        this.tip = object.tip;
    }

    getQuote(): string {
        return this.quote;
    }

    getQuoteFrom(): string {
        return this.quoteFrom;
    }
    
    getTip(): string {
        return documentToHtmlString(this.tip);
    }

    getType(): string {
        return 'tip';
    }
};
